/* MOVINGCOLD — theme behaviour. Cuts and fades. Nothing bounces. */
(function () {
  "use strict";

  /* ---- Product video: poster card, click to play with sound ---- */
  function initVideo() {
    document.querySelectorAll("[data-mc-video]").forEach(function (wrap) {
      var video = wrap.querySelector("video");
      var poster = wrap.querySelector("[data-mc-poster]");
      if (!video || !poster) return;

      function start() {
        poster.hidden = true;
        video.setAttribute("controls", "");
        video.muted = false;
        var p = video.play();
        if (p && typeof p.catch === "function") {
          p.catch(function () {           // browser blocked audio: fall back to muted
            video.muted = true;
            var q = video.play();
            if (q && typeof q.catch === "function") q.catch(function () {});
          });
        }
        video.focus({ preventScroll: true });
      }
      poster.addEventListener("click", start);
    });
  }


  /* ============================================================
     Lightbox: native scroll-snap for the swipe, Pointer Events for the zoom.
     Swiping is left to the browser (momentum + snap in native code) until the
     user zooms; then the track is frozen and a drag pans the image instead.
     ============================================================ */
  function initLightbox() {
    var lb = document.querySelector("[data-mc-lb]");
    var gallery = document.querySelector("[data-mc-gallery]");
    if (!lb || !gallery) return;

    var track = lb.querySelector("[data-mc-lb-track]");
    var slides = [].slice.call(lb.querySelectorAll("[data-mc-lb-slide]"));
    var thumbs = [].slice.call(lb.querySelectorAll("[data-mc-lb-thumb]"));
    var counter = lb.querySelector("[data-mc-lb-count]");
    var btnPrev = lb.querySelector("[data-mc-lb-prev]");
    var btnNext = lb.querySelector("[data-mc-lb-next]");
    var btnClose = lb.querySelector("[data-mc-lb-close]");
    var btnZoom = lb.querySelector("[data-mc-lb-zoom]");
    var stage = lb.querySelector("[data-mc-lb-stage]");
    if (!track || !slides.length) return;

    var MIN = 1, MAX = 6, STEP = 2.4;
    var index = 0, lastFocus = null;
    var z = { s: 1, x: 0, y: 0 };
    var pointers = new Map();
    var gesture = null, closeDrag = null, mouseDrag = null;
    var lastTap = 0, lastTapX = 0, lastTapY = 0, suppressClick = false;

    function img() { return slides[index].querySelector("img"); }

    /* A percentage max-height can silently fail to resolve inside a stretched
       flex item, and the image then overflows the stage on short windows.
       Pin it in pixels instead — measured, not inherited. */
    function sizeImages() {
      var sl = slides[0];
      if (!sl || !sl.clientHeight) return;
      var h = sl.clientHeight - 2 * parseFloat(getComputedStyle(sl).paddingTop || 0);
      var w = sl.clientWidth - 2 * parseFloat(getComputedStyle(sl).paddingLeft || 0);
      if (h <= 0 || w <= 0) return;
      slides.forEach(function (s) {
        var im = s.querySelector("img");
        if (!im) return;
        im.style.maxHeight = h + "px";
        im.style.maxWidth = w + "px";
      });
    }
    function pad(n) { return (n < 10 ? "0" : "") + n; }

    /* ---- zoom maths ---------------------------------------------------- */
    function clampPan() {
      var im = img(), sl = slides[index];
      if (!im) return;
      var w = im.offsetWidth * z.s, h = im.offsetHeight * z.s;
      var cw = sl.clientWidth, ch = sl.clientHeight;
      var ox = im.offsetLeft, oy = im.offsetTop;
      z.x = w <= cw ? (cw - w) / 2 - ox : Math.min(-ox, Math.max(cw - ox - w, z.x));
      z.y = h <= ch ? (ch - h) / 2 - oy : Math.min(-oy, Math.max(ch - oy - h, z.y));
    }
    function paint(animate) {
      var im = img();
      if (!im) return;
      im.classList.toggle("is-dragging", !animate);
      im.style.transform = z.s === 1 ? "" : "translate(" + z.x + "px," + z.y + "px) scale(" + z.s + ")";
      var on = z.s > 1;
      lb.classList.toggle("is-zoomed", on);
      if (btnZoom) btnZoom.textContent = on ? "RESET" : "ZOOM +";
    }
    function resetZoom(animate) {
      z.s = 1; z.x = 0; z.y = 0;
      paint(animate !== false);
    }
    /* zoom to `scale` keeping the point under (cx,cy) in place */
    function zoomAt(scale, cx, cy, animate) {
      var im = img(), sl = slides[index];
      if (!im) return;
      scale = Math.min(MAX, Math.max(MIN, scale));
      var r = sl.getBoundingClientRect();
      var sx = cx - r.left, sy = cy - r.top;
      var px = (sx - (im.offsetLeft + z.x)) / z.s;
      var py = (sy - (im.offsetTop + z.y)) / z.s;
      z.s = scale;
      z.x = sx - im.offsetLeft - scale * px;
      z.y = sy - im.offsetTop - scale * py;
      clampPan();
      paint(animate !== false);
    }
    /* A portrait page in a landscape window is limited by height, so a fixed
       step barely helps on a laptop: zoom at least far enough to fill the width. */
    function stepFor() {
      var im = img(), sl = slides[index];
      if (!im || !im.offsetWidth) return STEP;
      return Math.min(4, Math.max(STEP, sl.clientWidth / im.offsetWidth));
    }
    function toggleZoom(cx, cy) {
      if (z.s > 1) { resetZoom(true); return; }
      var r = stage.getBoundingClientRect();
      zoomAt(stepFor(), cx == null ? r.left + r.width / 2 : cx, cy == null ? r.top + r.height / 2 : cy, true);
    }

    /* ---- navigation ---------------------------------------------------- */
    function jump(i, smooth) {
      i = Math.min(slides.length - 1, Math.max(0, i));
      resetZoom(false);
      if (!smooth) track.style.scrollBehavior = "auto";
      track.scrollLeft = i * track.clientWidth;
      if (!smooth) {
        // force a reflow so the jump is not animated, then restore
        void track.offsetWidth;
        track.style.scrollBehavior = "";
      }
      setIndex(i);
    }
    function setIndex(i) {
      index = i;
      if (counter) counter.textContent = pad(i + 1) + " / " + pad(slides.length);
      thumbs.forEach(function (t, n) { t.setAttribute("aria-current", String(n === i)); });
      if (btnPrev) btnPrev.disabled = i === 0;
      if (btnNext) btnNext.disabled = i === slides.length - 1;
      var t = thumbs[i];
      if (t && t.scrollIntoView) t.scrollIntoView({ block: "nearest", inline: "nearest" });
    }

    /* Keep the counter in sync while the browser does the snapping. The observer
       is the cheap path; the debounced scroll listener is the backstop for when
       observer callbacks are throttled or unsupported. */
    function syncFromScroll() {
      var i = Math.round(track.scrollLeft / track.clientWidth);
      if (i > -1 && i < slides.length && i !== index) { resetZoom(false); setIndex(i); }
    }
    if ("IntersectionObserver" in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) {
            var i = slides.indexOf(e.target);
            if (i > -1 && i !== index) { resetZoom(false); setIndex(i); }
          }
        });
      }, { root: track, threshold: 0.6 });
      slides.forEach(function (s) { io.observe(s); });
    }
    var scrollTimer = null;
    track.addEventListener("scroll", function () {
      if (mouseDrag) return;                    // mid-drag: settle on release
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(syncFromScroll, 90);
    }, { passive: true });

    /* ---- open / close --------------------------------------------------- */
    function open(i) {
      lastFocus = document.activeElement;
      lb.hidden = false;
      document.body.classList.add("mc-lb-locked");
      sizeImages();
      jump(i, false);
      if (btnClose) btnClose.focus();
      document.addEventListener("keydown", onKey);
    }
    function close() {
      resetZoom(false);
      lb.hidden = true;
      lb.style.transform = "";
      lb.style.opacity = "";
      document.body.classList.remove("mc-lb-locked");
      document.removeEventListener("keydown", onKey);
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }
    function onKey(e) {
      if (lb.hidden) return;
      if (e.key === "Escape") { e.preventDefault(); close(); }
      else if (e.key === "ArrowRight") { e.preventDefault(); jump(index + 1, true); }
      else if (e.key === "ArrowLeft") { e.preventDefault(); jump(index - 1, true); }
      else if (e.key === "+" || e.key === "=") { e.preventDefault(); toggleZoom(); }
      else if (e.key === "-" || e.key === "0") { e.preventDefault(); resetZoom(true); }
      else if (e.key === "Tab") {
        var f = [].slice.call(lb.querySelectorAll("button:not([disabled]):not([hidden])"));
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }

    slides.forEach(function (s) {
      var im = s.querySelector("img");
      if (im) im.addEventListener("load", function () { sizeImages(); clampPan(); paint(false); });
    });

    gallery.querySelectorAll("[data-mc-gal-item]").forEach(function (el, i) {
      el.addEventListener("click", function () { open(i); });
    });
    if (btnClose) btnClose.addEventListener("click", close);
    if (btnPrev) btnPrev.addEventListener("click", function () { jump(index - 1, true); });
    if (btnNext) btnNext.addEventListener("click", function () { jump(index + 1, true); });
    if (btnZoom) btnZoom.addEventListener("click", function () { toggleZoom(); });
    thumbs.forEach(function (t, i) { t.addEventListener("click", function () { jump(i, true); }); });
    window.addEventListener("resize", function () {
      if (lb.hidden) return;
      sizeImages(); resetZoom(false); jump(index, false);
    });

    /* ---- pointer gestures ------------------------------------------------ */
    function mid(a, b) { return { x: (a.x + b.x) / 2, y: (a.y + b.y) / 2 }; }
    function dist(a, b) { return Math.hypot(a.x - b.x, a.y - b.y); }

    stage.addEventListener("pointerdown", function (e) {
      if (lb.hidden) return;
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

      if (pointers.size === 2) {                     // pinch starts: take control
        var p = Array.from(pointers.values());
        var m = mid(p[0], p[1]);
        var im = img(), sl = slides[index];
        var r = sl.getBoundingClientRect();
        gesture = {
          d0: dist(p[0], p[1]), s0: z.s,
          px: (m.x - r.left - (im.offsetLeft + z.x)) / z.s,
          py: (m.y - r.top - (im.offsetTop + z.y)) / z.s
        };
        closeDrag = null; mouseDrag = null;
        return;
      }
      if (pointers.size > 2) return;

      if (z.s > 1) {                                  // pan the zoomed image
        gesture = { pan: true, moved: false, x: e.clientX, y: e.clientY, x0: z.x, y0: z.y };
        slides[index].classList.add("is-panning");
        try { stage.setPointerCapture(e.pointerId); } catch (err) {}
      } else if (e.pointerType === "mouse") {         // desktop: drag to swipe
        mouseDrag = { x: e.clientX, y: e.clientY, left: track.scrollLeft, from: index, moved: false };
        // mandatory snapping would yank a programmatic scrollLeft straight back
        track.style.scrollBehavior = "auto";
        track.style.scrollSnapType = "none";
      } else {                                        // touch: drag down to close
        closeDrag = { x: e.clientX, y: e.clientY, active: false };
      }
    });

    stage.addEventListener("pointermove", function (e) {
      if (lb.hidden || !pointers.has(e.pointerId)) return;
      pointers.set(e.pointerId, { x: e.clientX, y: e.clientY });

      if (gesture && gesture.d0) {                    // pinch
        var p = Array.from(pointers.values());
        if (p.length < 2) return;
        var m = mid(p[0], p[1]);
        var sl = slides[index], im = img();
        var r = sl.getBoundingClientRect();
        var s = Math.min(MAX, Math.max(MIN, gesture.s0 * (dist(p[0], p[1]) / gesture.d0)));
        z.s = s;
        z.x = m.x - r.left - im.offsetLeft - s * gesture.px;
        z.y = m.y - r.top - im.offsetTop - s * gesture.py;
        clampPan(); paint(false);
        e.preventDefault();
        return;
      }
      if (gesture && gesture.pan) {                   // pan
        if (Math.hypot(e.clientX - gesture.x, e.clientY - gesture.y) > 4) gesture.moved = true;
        z.x = gesture.x0 + (e.clientX - gesture.x);
        z.y = gesture.y0 + (e.clientY - gesture.y);
        clampPan(); paint(false);
        e.preventDefault();
        return;
      }
      if (mouseDrag) {                                // desktop swipe
        var dx = e.clientX - mouseDrag.x;
        if (Math.abs(dx) > 3) mouseDrag.moved = true;
        track.scrollLeft = mouseDrag.left - dx;
        e.preventDefault();
        return;
      }
      if (closeDrag) {                                // pull down to dismiss
        var ddx = e.clientX - closeDrag.x, ddy = e.clientY - closeDrag.y;
        if (!closeDrag.active && ddy > 12 && Math.abs(ddy) > Math.abs(ddx) * 1.4) closeDrag.active = true;
        if (closeDrag.active) {
          lb.style.transform = "translateY(" + Math.max(0, ddy) + "px)";
          lb.style.opacity = String(Math.max(0.3, 1 - Math.max(0, ddy) / 420));
        }
      }
    }, { passive: false });

    function endPointer(e) {
      // A release only counts as a tap when nothing was actually dragged —
      // otherwise a pinch or pan lands inside the double-tap window.
      var swallowTap = (gesture && (gesture.d0 || gesture.moved)) ||
                       (mouseDrag && mouseDrag.moved) ||
                       (closeDrag && closeDrag.active);
      pointers.delete(e.pointerId);

      if (gesture && gesture.d0 && pointers.size < 2) {   // pinch ended
        gesture = null;
        if (z.s <= 1.02) resetZoom(true); else { clampPan(); paint(true); }
        if (pointers.size === 1 && z.s > 1) {             // one finger left: keep panning
          var rest = Array.from(pointers.entries())[0];
          gesture = { pan: true, moved: true, x: rest[1].x, y: rest[1].y, x0: z.x, y0: z.y };
        }
      } else if (gesture && gesture.pan && pointers.size === 0) {
        gesture = null;
        slides[index].classList.remove("is-panning");
      }

      if (mouseDrag && pointers.size === 0) {
        if (mouseDrag.moved) suppressClick = true;
        // anchor on the index we started from: reading scrollLeft mid-animation
        // misreads a second flick that lands before the first has settled
        var from = mouseDrag.from;
        var moved = track.scrollLeft - mouseDrag.left;
        mouseDrag = null;
        track.style.scrollBehavior = "";
        // a flick should advance, so use a short threshold instead of half a slide
        var land = Math.abs(moved) > track.clientWidth * 0.12 ? from + (moved > 0 ? 1 : -1) : from;
        land = Math.min(slides.length - 1, Math.max(0, land));
        track.scrollTo({ left: land * track.clientWidth, behavior: "smooth" });
        setIndex(land);
        // snapping back on only once the glide has finished, or it jumps
        setTimeout(function () { track.style.scrollSnapType = ""; }, 420);
      }

      if (closeDrag && pointers.size === 0) {
        var dy = e.clientY - closeDrag.y;
        var pulled = closeDrag.active;
        closeDrag = null;
        lb.style.transition = "transform var(--dur-base) var(--ease-out),opacity var(--dur-base) var(--ease-out)";
        lb.style.transform = ""; lb.style.opacity = "";
        setTimeout(function () { lb.style.transition = ""; }, 240);
        if (pulled) { if (dy > 90) close(); return; }
      }

      // A tap only counts as a tap when no gesture was running: releasing a
      // pinch used to land inside the double-tap window and jump the zoom.
      if (swallowTap) { lastTap = 0; return; }
      if (pointers.size > 0) return;

      if (e.pointerType !== "mouse") {
        var now = Date.now();
        if (now - lastTap < 300 && Math.hypot(e.clientX - lastTapX, e.clientY - lastTapY) < 30) {
          toggleZoom(e.clientX, e.clientY);
          lastTap = 0;
          return;
        }
        lastTap = now; lastTapX = e.clientX; lastTapY = e.clientY;
      }
    }
    stage.addEventListener("pointerup", endPointer);
    stage.addEventListener("pointercancel", function (e) {
      pointers.delete(e.pointerId);
      gesture = null; mouseDrag = null;
      if (closeDrag) { closeDrag = null; lb.style.transform = ""; lb.style.opacity = ""; }
      track.style.scrollBehavior = "";
      track.style.scrollSnapType = "";
      if (slides[index]) slides[index].classList.remove("is-panning");
    });
    stage.addEventListener("dblclick", function (e) {
      if (e.pointerType === "touch") return;
      e.preventDefault();
      toggleZoom(e.clientX, e.clientY);
    });
    /* trackpad pinch arrives as ctrl+wheel */
    stage.addEventListener("wheel", function (e) {
      if (lb.hidden) return;
      if (e.ctrlKey) {
        e.preventDefault();
        zoomAt(z.s * (1 - e.deltaY / 220), e.clientX, e.clientY, false);
      } else if (z.s > 1) {
        e.preventDefault();
        z.x -= e.deltaX; z.y -= e.deltaY;
        clampPan(); paint(false);
      }
    }, { passive: false });
    /* tapping the empty space around the image closes — but never a control,
       and never the click that ends a drag */
    stage.addEventListener("click", function (e) {
      if (suppressClick) { suppressClick = false; return; }
      if (z.s > 1) return;
      if (e.target.closest("button")) return;
      if (e.target.tagName !== "IMG") close();
    });
  }


  /* ---- Product carousel: one photo, swipe for the rest ---- */
  function initCarousel() {
    document.querySelectorAll("[data-mc-carousel]").forEach(function (root) {
      var track = root.querySelector("[data-mc-car-track]");
      var slides = [].slice.call(root.querySelectorAll("[data-mc-car-slide]"));
      var thumbs = [].slice.call(root.querySelectorAll("[data-mc-car-thumb]"));
      var counter = root.querySelector("[data-mc-car-count]");
      var prev = root.querySelector("[data-mc-car-prev]");
      var next = root.querySelector("[data-mc-car-next]");
      if (!track || slides.length < 2) return;
      var index = 0;

      function pad(n) { return (n < 10 ? "0" : "") + n; }
      function setIndex(i) {
        if (i < 0 || i >= slides.length) return;
        index = i;
        if (counter) counter.textContent = pad(i + 1) + " / " + pad(slides.length);
        thumbs.forEach(function (t, n) { t.setAttribute("aria-current", String(n === i)); });
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i === slides.length - 1;
        var t = thumbs[i];
        if (t && t.scrollIntoView) t.scrollIntoView({ block: "nearest", inline: "nearest" });
      }
      function goTo(i) {
        i = Math.min(slides.length - 1, Math.max(0, i));
        var target = i * track.clientWidth;
        track.scrollTo({ left: target, behavior: "smooth" });
        setIndex(i);
        // if smooth scrolling never starts, land it anyway — but not if the
        // reader has swiped somewhere else in the meantime
        setTimeout(function () {
          if (index === i && Math.abs(track.scrollLeft - target) > 2) {
            track.style.scrollBehavior = "auto";
            track.scrollLeft = target;
            track.style.scrollBehavior = "";
          }
        }, 500);
      }

      if (prev) prev.addEventListener("click", function () { goTo(index - 1); });
      if (next) next.addEventListener("click", function () { goTo(index + 1); });
      thumbs.forEach(function (t, i) { t.addEventListener("click", function () { goTo(i); }); });

      /* observer for the cheap path, debounced scroll as the backstop */
      function syncFromScroll() {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== index) setIndex(i);
      }
      if ("IntersectionObserver" in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              var i = slides.indexOf(e.target);
              if (i > -1 && i !== index) setIndex(i);
            }
          });
        }, { root: track, threshold: 0.6 });
        slides.forEach(function (s) { io.observe(s); });
      }
      var timer = null;
      track.addEventListener("scroll", function () {
        clearTimeout(timer); timer = setTimeout(syncFromScroll, 90);
      }, { passive: true });

      /* a swipe must not count as a tap on the photo */
      var startX = 0, startY = 0, moved = false;
      track.addEventListener("pointerdown", function (e) { startX = e.clientX; startY = e.clientY; moved = false; });
      track.addEventListener("pointermove", function (e) {
        if (Math.hypot(e.clientX - startX, e.clientY - startY) > 8) moved = true;
      });
      slides.forEach(function (sl) {
        sl.addEventListener("click", function (e) {
          if (moved) { e.preventDefault(); e.stopImmediatePropagation(); moved = false; }
        }, true);
      });

      window.addEventListener("resize", function () {
        track.scrollLeft = index * track.clientWidth;
      });
      setIndex(0);
    });
  }

  /* ---- Marquee: duplicate items so the loop is seamless ---- */
  function initMarquee() {
    document.querySelectorAll("[data-mc-marquee-track]").forEach(function (track) {
      if (track.dataset.mcCloned) return;
      track.innerHTML += track.innerHTML; // one full clone -> 50% translate loops perfectly
      track.dataset.mcCloned = "1";
    });
  }

  /* ---- Email capture forms: validate before enabling submit ---- */
  var EMAIL_RE = /.+@.+\..+/;
  function initEmailForms() {
    document.querySelectorAll("[data-mc-email-form]").forEach(function (form) {
      var input = form.querySelector('input[type="email"]');
      var btn = form.querySelector("[data-mc-email-submit]");
      if (!input || !btn) return;

      function sync() {
        var ok = EMAIL_RE.test(input.value.trim());
        btn.classList.toggle("is-disabled", !ok);
        btn.disabled = !ok;
      }
      input.addEventListener("input", sync);
      sync();
    });
  }

  /* ---- Show the success panel if Shopify redirected back with ?customer_posted=true ---- */
  function initFormSuccess() {
    if (!/[?&]customer_posted=true/.test(window.location.search)) return;
    document.querySelectorAll("[data-mc-form-default]").forEach(function (el) { el.hidden = true; });
    document.querySelectorAll("[data-mc-form-success]").forEach(function (el) { el.hidden = false; });
  }

  /* ---- Cart: agreement gate (v20 — never leaves a dead button) ----
     The checkout button stays clickable at all times. If the box is not ticked we
     block the submit ourselves and show the hint, so a stale JS state can never
     lock a customer out of checkout. ---- */
  function initCartWaiver() {
    var form = document.querySelector("[data-mc-cart-form]");
    var box = document.querySelector("[data-mc-waiver]");
    var checkout = document.querySelector("[data-mc-checkout]");
    if (!box || !checkout) return;
    var hint = document.querySelector("[data-mc-waiver-hint]");

    function paint() {
      var ok = box.checked;
      checkout.classList.toggle("is-locked", !ok);
      checkout.setAttribute("aria-disabled", ok ? "false" : "true");
      if (ok && hint) hint.hidden = true;
    }

    function block(e) {
      if (box.checked) return;
      e.preventDefault();
      if (hint) hint.hidden = false;
      try { box.focus({ preventScroll: false }); } catch (err) { box.focus(); }
      paint();
    }

    box.addEventListener("change", paint);
    checkout.addEventListener("click", block);
    if (form) form.addEventListener("submit", function (e) {
      if (e.submitter && e.submitter.name === "checkout") block(e);
    });

    // Browsers restore checkbox state on back-navigation: re-sync then too.
    window.addEventListener("pageshow", paint);
    paint();
  }

  /* ---- Cart: quantity stepper (v20) — +/- buttons that save on their own ---- */
  function initCartQty() {
    var form = document.querySelector("[data-mc-cart-form]");
    if (!form) return;
    var save = form.querySelector('[name="update"]');

    form.addEventListener("click", function (e) {
      var btn = e.target.closest("[data-mc-qty-step]");
      if (!btn) return;
      e.preventDefault();
      var wrap = btn.closest("[data-mc-qty]");
      var input = wrap && wrap.querySelector("input");
      if (!input) return;

      var step = parseInt(btn.getAttribute("data-mc-qty-step"), 10) || 0;
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + step);
      if (next === (parseInt(input.value, 10) || 0)) return;
      input.value = next;
      wrap.classList.add("is-busy");
      if (save) save.click(); else form.submit();
    });

    // Typing a number and leaving the field saves it too.
    form.addEventListener("change", function (e) {
      if (!e.target.matches("[data-mc-qty] input")) return;
      var v = parseInt(e.target.value, 10);
      e.target.value = isNaN(v) || v < 0 ? 0 : v;
      var wrap = e.target.closest("[data-mc-qty]");
      if (wrap) wrap.classList.add("is-busy");
      if (save) save.click(); else form.submit();
    });
  }

  /* ---- Mobile menu: open/close full-screen overlay ---- */
  function initMenu() {
    var menu = document.querySelector("[data-mc-menu]");
    var openBtn = document.querySelector("[data-mc-menu-open]");
    var closeBtn = document.querySelector("[data-mc-menu-close]");
    if (!menu || !openBtn) return;

    function open() {
      menu.hidden = false;
      document.body.classList.add("mc-menu-locked");
      openBtn.setAttribute("aria-expanded", "true");
      var first = menu.querySelector("a");
      if (first) first.focus();
    }
    function close() {
      menu.hidden = true;
      document.body.classList.remove("mc-menu-locked");
      openBtn.setAttribute("aria-expanded", "false");
      openBtn.focus();
    }

    openBtn.addEventListener("click", open);
    if (closeBtn) closeBtn.addEventListener("click", close);
    // Close after tapping a destination.
    menu.querySelectorAll(".mc-menu__nav a").forEach(function (a) {
      a.addEventListener("click", close);
    });
    // Escape closes.
    document.addEventListener("keydown", function (e) {
      if (e.key === "Escape" && !menu.hidden) close();
    });
  }

  function ready(fn) {
    if (document.readyState !== "loading") fn();
    else document.addEventListener("DOMContentLoaded", fn);
  }
  ready(function () {
    initVideo();
    initLightbox();
    initCarousel();
    initMarquee();
    initEmailForms();
    initFormSuccess();
    initCartWaiver();
    initCartQty();
    initMenu();
  });
})();
